/**********************************************************************************
 **********************************************************************************
 * OLD CODES
 **********************************************************************************
 *********************************************************************************/

class AnnouncementBar extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(this)

			const autoplayEnabled = this.getAttribute('data-autoplay-enabled') === 'true'
			const autoplayDelay = parseInt(this.getAttribute('data-autoplay-delay'), 10) || 3000

			const swiperOptions = {
				slidesPerView: 1,
				spaceBetween: 50,
				loop: true,
				effect: 'fade',
				centeredSlides: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			}

			if (autoplayEnabled) {
				swiperOptions.autoplay = {
					delay: autoplayDelay,
					disableOnInteraction: false,
				}
			}

			new Swiper('.swiper-announcementbar-slider', swiperOptions)
		}

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 400px 0px',
		}).observe(this)
	}
}

customElements.define('announcement-bar', AnnouncementBar)

class CustomProductItem extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(entries[0].target)

			new Swiper('.collection-item-slider-' + this.getAttribute('data-pid'), {
				spaceBetween: 20,
				slidesPerView: 1,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				pagination: {
					el: '.swiper-pagination',
					dynamicBullets: true,
				},
			})
		}

		const observer = new IntersectionObserver(handleIntersection, {
			rootMargin: '0px 0px 300px 0px',
		})

		observer.observe(this)
	}
}

customElements.define('custom-product-item', CustomProductItem)

class CustomTabView extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(entries[0].target)

			jQuery(document).ready(function ($) {
				$('.tab-title').eq(0).addClass('active-title')
				$('.tab-content').eq(0).addClass('active')
				$('.tab-title').click(function () {
					var title = $(this).attr('title')
					$('.tab-title').removeClass('active-title')
					$(this).addClass('active-title')
					$('.tab-content').removeClass('active')
					$('.tab-content[content="' + title + '"]').addClass('active')
				})

				var $type = $('.product__block--product-header').data('tag')
				$('.match-top-heading').hide()
				$(".match-top-heading[id='" + $type + "']").show()
			})
		}

		const observer = new IntersectionObserver(handleIntersection, {
			rootMargin: '0px 0px 300px 0px',
		})

		observer.observe(this)
	}
}

customElements.define('custom-tab-view', CustomTabView)

class CustomImageSlider extends HTMLElement {
	constructor() {
		super()
	}
	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(this)
			var this2 = $(this)
			$(this2).css({ opacity: '1' })

			var autoplay = $(this).data('autoplay')

			if (autoplay == false) {
				var swiper = new Swiper('.slide-image-' + this.getAttribute('data-sectionid'), {
					spaceBetween: 15,
					slidesPerView: 4.5,
					loop: true,
					breakpoints: {
						450: {
							slidesPerView: 4.5,
							spaceBetween: 15,
						},
						550: {
							slidesPerView: 4.5,
							spaceBetween: 15,
						},
						640: {
							slidesPerView: 4,
							spaceBetween: 15,
						},
						768: {
							slidesPerView: 6,
							spaceBetween: 25,
						},
						1024: {
							slidesPerView: 9,
							spaceBetween: 30,
						},
						1199: {
							slidesPerView: 8,
							spaceBetween: 30,
							loop: true,
						},
						1441: {
							slidesPerView: 9,
							spaceBetween: 35,
						},
					},
				})
			} else {
				var swiper = new Swiper('.slide-image-' + this.getAttribute('data-sectionid'), {
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
					},
					effect: 'linear',
					spaceBetween: 6,
					slidesPerView: 4.5,
					loop: true,
					speed: 3000,
					breakpoints: {
						450: {
							slidesPerView: 4.5,
							spaceBetween: 6,
						},
						550: {
							slidesPerView: 4.5,
							spaceBetween: 6,
						},
						640: {
							slidesPerView: 7.5,
							spaceBetween: 6,
						},
						768: {
							slidesPerView: 8.5,
							spaceBetween: 28,
							loop: true,
						},
						1024: {
							slidesPerView: 9.5,
							spaceBetween: 28,
							loop: true,
						},
						1441: {
							slidesPerView: 10.5,
							spaceBetween: 28,
							loop: true,
						},
						1600: {
							slidesPerView: 14.5,
							spaceBetween: 28,
							loop: true,
						},
					},
				})
			}
		}
		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 400px 0px',
		}).observe(this)
	}
}
customElements.define('custom-image-slider', CustomImageSlider)

class CustomAnnouncementBar extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(entries[0].target)

			var anntype = $(this).data('anntype')

			if (anntype == 'scrolling') {
				var swiper = new Swiper('.announcemment-bar-slider', {
					slidesPerView: 'auto',
					spaceBetween: 30,
					allowTouchMove: false,
					freeModeMomentum: false,
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
					},
					effect: 'linear',
					loop: true,
					speed: 5000,
					freeMode: true,
					breakpoints: {
						640: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
						660: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
						769: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
						945: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
						1024: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
						1300: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
						1441: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
					},
				})

				var swiper = new Swiper('.announcemment-bar-slidermob', {
					spaceBetween: 30,
					slidesPerView: 'auto',
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
					},
					freeModeMomentum: false,
					freeMode: true,
					effect: 'linear',
					loop: true,
					speed: 5000,
					allowTouchMove: false,
					breakpoints: {
						640: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
						660: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
						769: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
						945: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
						1024: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
						1440: {
							slidesPerView: 'auto',
							spaceBetween: 30,
						},
					},
				})
			} else {
				var swiper = new Swiper('.announcemment-bar-slider', {
					slidesPerView: 1,
					spaceBetween: 10,
					freeModeMomentum: false,
					freeMode: true,
					breakpoints: {
						500: {
							slidesPerView: 2,
							spaceBetween: 10,
						},
						600: {
							slidesPerView: 3,
							spaceBetween: 10,
						},
						768: {
							slidesPerView: 3.5,
							spaceBetween: 10,
						},
						945: {
							slidesPerView: 3.5,
							spaceBetween: 10,
						},
						1024: {
							slidesPerView: 4,
							spaceBetween: 10,
						},
					},
				})

				var swiper = new Swiper('.announcemment-bar-slidermob', {
					spaceBetween: 10,
					slidesPerView: 2,
					freeModeMomentum: false,
					freeMode: true,
					breakpoints: {
						500: {
							slidesPerView: 2,
							spaceBetween: 10,
						},
						600: {
							slidesPerView: 3,
							spaceBetween: 10,
						},
						768: {
							slidesPerView: 3.5,
							spaceBetween: 10,
						},
						945: {
							slidesPerView: 3.5,
							spaceBetween: 10,
						},
						1024: {
							slidesPerView: 4,
							spaceBetween: 10,
						},
					},
				})
			}
		}

		const observer = new IntersectionObserver(handleIntersection, {
			rootMargin: '0px 0px 300px 0px',
		})

		observer.observe(this)
	}
}
customElements.define('custom-announcement-bar', CustomAnnouncementBar)

class bannerslider extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return

			observer.unobserve(this)
			$(this).css({ opacity: '1' })

			new Swiper('.banner-slider--' + this.getAttribute('data-sectionid'), {
				pagination: {
					el: '.swiper-pagination',
				},
			})
		}

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 400px 0px',
		}).observe(this)
	}
}

customElements.define('banner-slider', bannerslider)

class BestSellerProducts extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(this)

			$('input[type="submit"]').on('click', function (event) {
				var this2 = $(this)
				var id = $(this).attr('data-value')

				var producttitle = $(this).data('producttitle')
				var productid = $(this).data('productid')
				var productprice = $(this).data('productprice')
				var productcurrency = $(this).data('currency')

				$.ajax({
					url: '/cart/add.js',
					type: 'POST',
					dataType: 'json',
					data: {
						id: id,
						quantity: 1,
					},
					success: function (data) {
						window.location.href = '/cart'
					},
				})

				window.__ii.send({
					eventName: 'PixelView',
					eventData: {
						product_id: productid,
						product_name: producttitle,
						price: parseFloat(productprice),
						currency: productcurrency,
					},
				})
			})
		}

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 400px 0px',
		}).observe(this)
	}
}

customElements.define('best-seller-products', BestSellerProducts)

class CustomHighlight extends HTMLElement {
	constructor() {
		super()
	}
	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(entries[0].target)

			var blocksize = $(this).data('blocksize')
			var sectionid = this.getAttribute('data-sectionid')
			var swiper = new Swiper('.highlight-swiper-slider-' + sectionid, {
				slidesPerView: 3,
				spaceBetween: 10,
				breakpoints: {
					0: {
						slidesPerView: 3,
						spaceBetween: 10,
					},
					769: {
						slidesPerView: 5,
						spaceBetween: 40,
					},
					1024: {
						slidesPerView: 6,
						spaceBetween: 73,
					},
				},
			})
		}
		const observer = new IntersectionObserver(handleIntersection, {
			rootMargin: '0px 0px 300px 0px',
		})
		observer.observe(this)
	}
}
customElements.define('custom-highlighted', CustomHighlight)

class CustomViewRoom extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(entries[0].target)

			$(this).css({ opacity: '1' })
			var slidetime = $(this).data('slide-time')
			var sectionid = this.getAttribute('data-sectionid')

			var swiperview = new Swiper('.main-lifestyle-wrapper-' + sectionid, {
				loop: true,
				spaceBetween: 0,
				slidesPerView: 1,
				effect: 'fade',
			})

			var swiperviewcard = new Swiper('.view-card-slider-' + sectionid, {
				loop: true,
				spaceBetween: 10,
				autoplay: {
					delay: slidetime,
					disableOnInteraction: false,
				},
			})
			swiperview.controller.control = swiperviewcard
			swiperviewcard.controller.control = swiperview

			$('.main-content-button')
				.unbind()
				.click(function () {
					$('.view-card-slider').find('.swiper-slide-active .card-image-button').click()
				})
		}

		const observer = new IntersectionObserver(handleIntersection, {
			rootMargin: '0px 0px 300px 0px',
		})

		observer.observe(this)
	}
}

customElements.define('custom-view-room', CustomViewRoom)

class CustomMainProductDefault extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(entries[0].target)

			jQuery(document).ready(function ($) {
				let modal_size = document.querySelector('#modal-size-guide')
				let btn_size = document.querySelector('#button-size')
				let close_btn_size = document.querySelector('#modal-close-size')

				btn_size.addEventListener('click', display)

				function display() {
					modal_size.style.display = 'block'
				}
				close_btn_size.addEventListener('click', hide)
				window.addEventListener('click', (event) => {
					if (event.target == modal_size) {
						modal_size.style.display = 'none'
					}
				})
				function hide() {
					modal_size.style.display = 'none'
				}

				$(document).on('click', '.custom_need_help-2', function () {
					console.log('test')
					if (document.getElementById('dummy-chat-button-iframe')) {
						document.getElementById('dummy-chat-button-iframe').contentDocument.querySelector('.chat-toggle').click()
					} else {
						document.getElementById('ShopifyChat').contentDocument.querySelector('.chat-toggle').click()
					}
				})

				$(document).ready(function () {
					if ($('.modal-custom-form').length > 0) {
						var modal = document.querySelector('.modal-custom-form')
						var trigger = document.querySelector('.custom_need_help-1')
						var closeButton = document.querySelector('.close-button')

						function toggleModal() {
							modal.classList.toggle('show-modal')
						}

						function windowOnClick(event) {
							if (event.target === modal) {
								toggleModal()
							}
						}

						trigger.addEventListener('click', toggleModal)
						closeButton.addEventListener('click', toggleModal)
						window.addEventListener('click', windowOnClick)
					}
				})
			})

			$(document).ready(function () {
				$('.product__media-show-more .btn--tertiary').click(function () {
					$(this).parents().find('.product__media-item--hide-on-load').toggleClass('product__media-item--show')

					if ($(this).parents().find('.product__media-item--hide-on-load').hasClass('product__media-item--show')) {
						$(this).text('Less Media')
					} else {
						$(this).text('More Media')
					}
				})

				var thumbswiper = new Swiper('.thumb_swiper', {
					slidesPerView: 4.8,
					freeMode: true,
					mousewheel: true,
					spaceBetween: 10,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				})

				var main_swiper = new Swiper('.main_swiper', {
					thumbs: {
						swiper: thumbswiper,
					},
					on: {
						slideChangeTransitionEnd: function () {
							manageVideoPlayback()
						},
					},
				})

				function manageVideoPlayback() {
					$('.main_swiper .swiper-slide video').each(function () {
						this.pause()
						this.currentTime = 0
						$('.plyr__control').css({ opacity: '1', visibility: 'visible' })
					})

					var activeSlide = $('.swiper-slide-active')
					var video = activeSlide.find('video')
					if (video.length) {
						video[0].play()
						$('.plyr__control').css({ opacity: '0', visibility: 'hidden' })
					} else {
						$('.plyr__control').css({ opacity: '1', visibility: 'visible' })
					}
				}

				document.addEventListener('repositionmainslidermob', (e) => {
					var index = e.detail.index
					main_swiper.slideTo(index)
					thumbswiper.slideTo(index)
				})

				$(document).ready(function () {
					$('.main_swiper .product__media-item-video')
						.unbind()
						.click(function () {
							var video = $(this).find('video').get(0)
							if (video) {
								if (video.paused) {
									console.log('play')
									video.play()
									$('.plyr__control').css({ opacity: '0', visibility: 'hidden' })
								} else {
									console.log('pause')
									video.pause()
									$('.plyr__control').css({ opacity: '1', visibility: 'visible' })
								}
							}
						})
				})

				if ($('.product__color-swatch').length > 0) {
					var imageindex = $('.product__color-swatch.selected').data('media-position')
					var indexposition = imageindex - 1

					const startEvent = new CustomEvent('repositionmainslider', {
						detail: { index: indexposition },
					})

					const startEventMob = new CustomEvent('repositionmainslidermob', {
						detail: { index: indexposition },
					})

					document.dispatchEvent(startEvent)
					document.dispatchEvent(startEventMob)
				}
			})
		}

		const observer = new IntersectionObserver(handleIntersection, {
			rootMargin: '0px 0px 300px 0px',
		})

		observer.observe(this)
	}
}

customElements.define('custom-main-product-default', CustomMainProductDefault)

// class CustomSlider extends HTMLElement {
// 	constructor() {
// 		super()
// 	}

// 	connectedCallback() {
// 		const handleIntersection = (entries, observer) => {
// 			if (!entries[0].isIntersecting) return
// 			observer.unobserve(this)

// 			$(this).css({ opacity: '1' })

// 			var galleryThumbs = new Swiper('.thumb-slider', {
// 				spaceBetween: 15,
// 				direction: 'horizontal',
// 				slidesPerView: 4,
// 				mousewheel: true,
// 				navigation: {
// 					nextEl: '.swiper-button-next',
// 					prevEl: '.swiper-button-prev',
// 				},
// 				breakpoints: {
// 					0: {
// 						slidesPerView: 4,
// 						spaceBetween: 15,
// 						direction: 'horizontal',
// 					},
// 					768: {
// 						slidesPerView: 4,
// 						spaceBetween: 15,
// 						direction: 'horizontal',
// 					},
// 					1024: {
// 						slidesPerView: 5,
// 						spaceBetween: 12,
// 						direction: 'vertical',
// 					},
// 					1441: {
// 						slidesPerView: 6,
// 						spaceBetween: 12,
// 						direction: 'vertical',
// 					},
// 				},
// 				navigation: {
// 					nextEl: '.swiper-button-next',
// 					prevEl: '.swiper-button-prev',
// 				},
// 			})

// 			var galleryTop = new Swiper('.main-slider', {
// 				spaceBetween: 15,
// 				direction: 'horizontal',
// 				thumbs: {
// 					swiper: galleryThumbs,
// 				},
// 				breakpoints: {
// 					0: {
// 						slidesPerView: 1,
// 						spaceBetween: 15,
// 						direction: 'horizontal',
// 					},
// 					768: {
// 						slidesPerView: 1,
// 						spaceBetween: 15,
// 						direction: 'horizontal',
// 					},
// 				},
// 			})

// 			document.addEventListener('repositionmainslider', (e) => {
// 				var index = e.detail.index
// 				galleryTop.slideTo(index)
// 				galleryThumbs.slideTo(index)
// 			})
// 		}

// 		new IntersectionObserver(handleIntersection.bind(this), {
// 			rootMargin: '0px 0px 400px 0px',
// 		}).observe(this)
// 	}
// }

// customElements.define('custom-slider', CustomSlider)

class CustomSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      $(this).css({
        opacity: "1"
      });

      const thumbSlider = this.querySelector(".thumb-slider");
      const mainSlider = this.querySelector(".main-slider");

      if (!mainSlider) return;

      var galleryThumbs = null;

      if (thumbSlider) {
        galleryThumbs = new Swiper(thumbSlider, {
          spaceBetween: 15,
          direction: "horizontal",
          slidesPerView: 4,
          mousewheel: true,

          navigation: {
            nextEl: thumbSlider.querySelector(".swiper-button-next"),
            prevEl: thumbSlider.querySelector(".swiper-button-prev"),
          },

          breakpoints: {
            0: {
              slidesPerView: 4,
              spaceBetween: 15,
              direction: "horizontal",
            },

            991: {
              slidesPerView: 4,
              spaceBetween: 15,
              direction: "horizontal",
            },

            1024: {
              slidesPerView: 5,
              spaceBetween: 12,
              direction: "vertical",
            },

            1441: {
              slidesPerView: 6,
              spaceBetween: 12,
              direction: "vertical",
            },
          },
        });
      }

      const sendVimeoCommand = (iframe, method, value) => {
        if (!iframe || !iframe.contentWindow) return;

        try {
          const message = {
            method: method
          };

          if (typeof value !== "undefined") {
            message.value = value;
          }

          iframe.contentWindow.postMessage(
            JSON.stringify(message),
            "*"
          );
        } catch (error) {}
      };

      const resetHtmlVideo = (video) => {
        if (!video) return;

        try {
          video.pause();
          video.currentTime = 0;
        } catch (error) {}
      };

      const playHtmlVideo = (video, reset = true) => {
        if (!video) return;

        try {
          video.pause();

          if (reset) {
            video.currentTime = 0;
          }

          video.muted = false;
          video.defaultMuted = false;
          video.volume = 1;
          video.playsInline = true;

          const playPromise = video.play();

          if (
            playPromise &&
            typeof playPromise.catch === "function"
          ) {
            playPromise.catch(function () {
              video.muted = true;

              const mutedPlayPromise = video.play();

              if (
                mutedPlayPromise &&
                typeof mutedPlayPromise.catch === "function"
              ) {
                mutedPlayPromise.catch(function () {});
              }
            });
          }
        } catch (error) {}
      };

      const resetVimeoVideo = (iframe) => {
        if (!iframe) return;

        sendVimeoCommand(iframe, "pause");
        sendVimeoCommand(iframe, "setCurrentTime", 0);
      };

      const playVimeoVideo = (iframe, reset = true) => {
        if (!iframe) return;

        sendVimeoCommand(iframe, "pause");

        if (reset) {
          sendVimeoCommand(iframe, "setCurrentTime", 0);
        }

        setTimeout(() => {
          sendVimeoCommand(iframe, "setVolume", 1);
          sendVimeoCommand(iframe, "play");
        }, 150);
      };

      const stopAllVideos = () => {
        mainSlider
          .querySelectorAll("video")
          .forEach((video) => {
            resetHtmlVideo(video);
          });

        mainSlider
          .querySelectorAll(
            'iframe[src*="player.vimeo.com"]'
          )
          .forEach((iframe) => {
            resetVimeoVideo(iframe);
          });
      };

      const playActiveSlideVideo = (swiper) => {
        if (!swiper) return;

        const activeSlide =
          swiper.slides[swiper.activeIndex];

        if (!activeSlide) return;

        const htmlVideo =
          activeSlide.querySelector("video");

        if (htmlVideo) {
          playHtmlVideo(htmlVideo, true);
          return;
        }

        const vimeoIframe =
          activeSlide.querySelector(
            'iframe[src*="player.vimeo.com"]'
          );

        if (vimeoIframe) {
          playVimeoVideo(vimeoIframe, true);
        }
      };

      var galleryTop = new Swiper(mainSlider, {
        spaceBetween: 15,
        direction: "horizontal",

        thumbs: galleryThumbs
          ? {
              swiper: galleryThumbs
            }
          : undefined,

        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 15,
            direction: "horizontal",
          },

          991: {
            slidesPerView: 1,
            spaceBetween: 15,
            direction: "horizontal",
          },
        },

        on: {
          init: function () {
            const swiper = this;

            setTimeout(() => {
              stopAllVideos();
              playActiveSlideVideo(swiper);
            }, 300);
          },

          slideChangeTransitionStart: function () {
            stopAllVideos();
          },

          slideChangeTransitionEnd: function () {
            playActiveSlideVideo(this);
          },
        },
      });

      let pausedLightboxVideo = null;
      let pausedLightboxVimeo = null;
      let pausedHtmlTime = 0;

      const pauseCurrentSliderVideo = () => {
        const activeSlide =
          galleryTop.slides[galleryTop.activeIndex];

        if (!activeSlide) return;

        pausedLightboxVideo = null;
        pausedLightboxVimeo = null;
        pausedHtmlTime = 0;

        const htmlVideo =
          activeSlide.querySelector("video");

        if (htmlVideo) {
          pausedLightboxVideo = htmlVideo;

          try {
            pausedHtmlTime = htmlVideo.currentTime;
            htmlVideo.pause();
          } catch (error) {}

          return;
        }

        const vimeoIframe =
          activeSlide.querySelector(
            'iframe[src*="player.vimeo.com"]'
          );

        if (vimeoIframe) {
          pausedLightboxVimeo = vimeoIframe;

          sendVimeoCommand(
            vimeoIframe,
            "pause"
          );
        }
      };

      const resumeCurrentSliderVideo = () => {
        const activeSlide =
          galleryTop.slides[galleryTop.activeIndex];

        if (!activeSlide) return;

        if (
          pausedLightboxVideo &&
          activeSlide.contains(pausedLightboxVideo)
        ) {
          try {
            pausedLightboxVideo.currentTime =
              pausedHtmlTime;

            playHtmlVideo(
              pausedLightboxVideo,
              false
            );
          } catch (error) {}
        }

        if (
          pausedLightboxVimeo &&
          activeSlide.contains(pausedLightboxVimeo)
        ) {
          playVimeoVideo(
            pausedLightboxVimeo,
            false
          );
        }

        pausedLightboxVideo = null;
        pausedLightboxVimeo = null;
        pausedHtmlTime = 0;
      };

      mainSlider.addEventListener(
        "click",
        function (event) {
          const lightboxTrigger =
            event.target.closest(".lightbox-video");

          if (!lightboxTrigger) return;

          pauseCurrentSliderVideo();
        }
      );

      document.addEventListener(
        "product-lightbox-close",
        function () {
          setTimeout(() => {
            resumeCurrentSliderVideo();
          }, 100);
        }
      );

      const repositionHandler = (e) => {
        if (
          !e.detail ||
          typeof e.detail.index === "undefined"
        ) {
          return;
        }

        var index = e.detail.index;

        stopAllVideos();

        galleryTop.slideTo(index);

        if (galleryThumbs) {
          galleryThumbs.slideTo(index);
        }
      };

      document.addEventListener(
        "repositionmainslider",
        repositionHandler
      );
    };

    new IntersectionObserver(
      handleIntersection.bind(this),
      {
        rootMargin: "0px 0px 400px 0px"
      }
    ).observe(this);
  }
}

if (!customElements.get("custom-slider")) {
  customElements.define(
    "custom-slider",
    CustomSlider
  );
}

$(document).on('click', '.tab-view-chat-container-inbox', function () {
	console.log('Opening Shopify Chat')
	const chatContainer = document.getElementById('ShopifyChat')

	if (chatContainer?.shadowRoot) {
		const chatToggle = chatContainer.shadowRoot.querySelector('.chat-toggle')
		if (chatToggle) {
			chatToggle.click()
		} else {
			console.warn('chat-toggle button not found inside shadowRoot')
		}
	} else {
		console.error('ShopifyChat shadowRoot not available')
	}
})

/**********************************************************************************
 **********************************************************************************
 * LTA CODES
 **********************************************************************************
 *********************************************************************************/

// =====================
// DOM Manipulation Utils
// =====================

function l_setInnerHTML(element, html) {
	element.innerHTML = html
	element.querySelectorAll('script').forEach((oldScript) => {
		const newScript = document.createElement('script')
		const attributes = [...oldScript.attributes]

		attributes.forEach((attr) => {
			newScript.setAttribute(attr.name, attr.value)
		})

		newScript.appendChild(document.createTextNode(oldScript.innerHTML))
		oldScript.parentNode.replaceChild(newScript, oldScript)
	})
}

function l_swapHtmlNode(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
	// Run pre-process callbacks on new content
	if (Array.isArray(preProcessCallbacks)) {
		preProcessCallbacks.forEach((cb) => cb?.(newContent))
	}

	// Create a new node from newContent's outerHTML (ensures scripts run)
	const wrapper = document.createElement('div')
	l_setInnerHTML(wrapper, newContent.outerHTML)
	const newNode = wrapper.firstElementChild

	// Deduplicate [id] and [form] in oldNode's subtree
	const timestampKey = Date.now()
	oldNode.querySelectorAll('[id], [form]').forEach((el) => {
		if (el.id) el.id = `${el.id}-${timestampKey}`
		if (el.form) {
			const formId = el.getAttribute('form')
			if (formId) el.setAttribute('form', `${formId}-${timestampKey}`)
		}
	})

	// Insert newNode before oldNode and hide oldNode
	oldNode.parentNode.insertBefore(newNode, oldNode)
	oldNode.style.display = 'none'

	// Run post-process callbacks
	if (Array.isArray(postProcessCallbacks)) {
		postProcessCallbacks.forEach((cb) => cb?.(newNode))
	}

	// Remove oldNode after transition
	setTimeout(() => {
		if (oldNode?.parentNode) oldNode.remove()
	}, 500)
}

function l_addClassesToRteTables() {
	document.querySelectorAll('.l-rte table, .shopify-policy__body .rte table').forEach((table) => {
		const wrapper = document.createElement('div')

		wrapper.classList.add('l-rte-table', 'l-overflow-x-auto', 'l-scrollbar--hidden')
		table.parentNode.insertBefore(wrapper, table)
		wrapper.appendChild(table)
	})
}

function l_getSectionDOM(html, selector = '.shopify-section') {
	return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
}

// =====================
// DOM Observation Utils
// =====================

const l_getElement = (targetSelector, container) => {
	if (targetSelector instanceof Element) return targetSelector
	if (typeof targetSelector === 'string') {
		return targetSelector.startsWith('#')
			? container.getElementById(targetSelector.slice(1))
			: container.querySelector(targetSelector)
	}

	return null
}

// =====================
// Focus Management & Trap Focus
// =====================

function isVisible(element) {
	if (!element) return false

	if (element.closest('[aria-hidden="true"], [hidden]')) return false

	const detailsParent = element.closest('details')
	if (detailsParent && !detailsParent.open && !detailsParent.contains(element.closest('summary'))) {
		return false
	}

	if (element.offsetParent === null && getComputedStyle(element).position !== 'fixed') {
		return false
	}

	const style = getComputedStyle(element)
	if (style.visibility === 'hidden' || style.visibility === 'collapse') return false

	if (element.getClientRects().length === 0) return false

	return true
}

function l_getFocusableElements(container) {
	const focusableSelectors = `summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe`

	return Array.from(container.querySelectorAll(focusableSelectors)).filter((el) => isVisible(el))
}

function l_disableFocusableElements(container) {
	l_getFocusableElements(container).forEach((el) => {
		el.setAttribute('tabindex', '-1')
		el.setAttribute('aria-disabled', 'true')
	})
}

function l_enableFocusableElements(container) {
	l_getFocusableElements(container).forEach((el) => {
		el.removeAttribute('tabindex')
		el.removeAttribute('aria-disabled')
	})
}

const l_trapFocusHandlers = {}

function l_trapFocus(container, defaultElementToFocus, enableFocusRange = true) {
	// cleanup any previous traps
	l_removeTrapFocus()

	l_trapFocusHandlers.keydown = (event) => {
		const key = event.code?.toUpperCase()
		const isTab = key === 'TAB'
		const isArrowDown = key === 'ARROWDOWN'
		const isArrowUp = key === 'ARROWUP'

		const elements = l_getFocusableElements(container)
		const [first, last] = [elements[0], elements[elements.length - 1]]
		const currentIndex = elements.indexOf(event.target)

		if (!elements.length) return

		if (isTab) {
			if ((event.target === last || last?.contains?.(event.target)) && !event.shiftKey) {
				event.preventDefault()
				first?.focus()
			} else if ((event.target === container || first?.contains?.(event.target)) && event.shiftKey) {
				event.preventDefault()
				last?.focus()
			}
			return
		}

		if (isArrowDown) {
			event.preventDefault()
			if (currentIndex === -1 || currentIndex === elements.length - 1) {
				first?.focus()
			} else {
				elements[currentIndex + 1]?.focus()
			}
			return
		}

		if (isArrowUp) {
			event.preventDefault()
			if (currentIndex === -1 || currentIndex === 0) {
				last?.focus()
			} else {
				elements[currentIndex - 1]?.focus()
			}
			return
		}
	}

	l_trapFocusHandlers.focusin = (event) => {
		if (container.contains(event.target)) {
			document.addEventListener('keydown', l_trapFocusHandlers.keydown)
		}
	}

	l_trapFocusHandlers.focusout = () => {
		document.removeEventListener('keydown', l_trapFocusHandlers.keydown)
	}

	document.addEventListener('focusin', l_trapFocusHandlers.focusin)
	document.addEventListener('focusout', l_trapFocusHandlers.focusout)

	// Initial focus
	const elements = l_getFocusableElements(container)
	const first = elements[0]
	const elementToFocus = defaultElementToFocus || first
	if (elementToFocus) {
		elementToFocus.focus()
		if (
			elementToFocus.tagName === 'INPUT' &&
			['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
			elementToFocus.value &&
			enableFocusRange
		) {
			elementToFocus.setSelectionRange(0, elementToFocus.value.length)
		}
	}
}

function l_removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', l_trapFocusHandlers.focusin)
	document.removeEventListener('focusout', l_trapFocusHandlers.focusout)
	document.removeEventListener('keydown', l_trapFocusHandlers.keydown)
	if (elementToFocus) elementToFocus.focus()
}

// =====================
// Scroll & Body Lock Utilities
// =====================

function l_setBodyScrollbarWidth() {
	const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
	document.documentElement.style.setProperty('--l-body-scrollbar-width', `${scrollBarWidth}px`)
}

function l_lockBodyScroll(elementName) {
	l_setBodyScrollbarWidth()

	// Add classes
	document.body.classList.add('js-block-page')

	if (elementName) {
		document.body.classList.add(`js-block-page-${elementName}`)
	}
}

function l_unLockBodyScroll(elementName) {
	// Remove classes
	if (elementName) {
		document.body.classList.remove(`js-block-page-${elementName}`)

		const isExistAnotherBlockedClass = Array.from(document.body.classList).some((cls) =>
			cls.startsWith('js-block-page-')
		)

		!isExistAnotherBlockedClass && document.body.classList.remove('js-block-page')
	} else {
		document.body.classList.remove('js-block-page')
	}
}

function l_setupVariablesBeforeOpenModal() {
	// // Elements
	// const announcementBarSection = document.getElementById('announcementBar')
	// const headerSection = document.getElementById('header')?.parentElement
	// // Set CSS variables
	// document.documentElement.style.setProperty('--l-viewport-height', `${visualViewport?.height ?? window.innerHeight}px`)
	// document.documentElement.style.setProperty('--l-header-height', `${headerSection?.offsetHeight || 0}px`)
	// document.documentElement.style.setProperty(
	// 	'--l-announcement-bar-height',
	// 	`${announcementBarSection?.offsetHeight || 0}px`
	// )
	// return {
	// 	headerHeight: headerSection?.offsetHeight || 0,
	// 	announcementBarHeight: announcementBarSection?.offsetHeight || 0,
	// 	headerTotalHeight: (headerSection?.offsetHeight || 0) + (announcementBarSection?.offsetHeight || 0),
	// 	viewportHeight: visualViewport?.height ?? window.innerHeight,
	// }
}

// =====================
// Media Controls
// =====================

function l_pauseAllMedia(container = document) {
	container.querySelectorAll('l-external-media').forEach((video) => {
		video?.pauseVideo?.()
	})
	container.querySelectorAll('.js-youtube').forEach((youtubeVideo) => {
		youtubeVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
	})
	container.querySelectorAll('.js-vimeo').forEach((vimeoVideo) => {
		vimeoVideo.contentWindow.postMessage('{"method":"pause"}', '*')
	})
	container.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
	container.querySelectorAll('video').forEach((video) => {
		video.pause()
	})
}

function l_playMedia(container = document) {
	container.querySelectorAll('l-external-media').forEach((video) => {
		video?.playVideo?.()
	})
	container.querySelectorAll('.js-youtube').forEach((youtubeVideo) => {
		youtubeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
	})
	container.querySelectorAll('.js-vimeo').forEach((vimeoVideo) => {
		vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*')
	})
	container.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.play()
	})
	container.querySelectorAll('video').forEach((video) => {
		video.play()
	})
}

// =====================
// Event/Utility Functions
// =====================

function l_debounce(fn, wait) {
	let t

	return function (...args) {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

function l_addEventDelegate({
	context = document.documentElement,
	event = 'click',
	selector,
	handler,
	capture = false,
}) {
	if (!context) return

	const listener = function (e) {
		// loop parent nodes from the target to the delegation node
		for (let target = e.target; target && target !== this; target = target.parentNode) {
			if (target.matches(selector)) {
				handler.call(target, e, target)
				break
			}
		}
	}

	context.addEventListener(event, listener, capture)

	return () => {
		context.removeEventListener(event, listener, capture)
	}
}

function l_fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
	}
}

// =====================
// Input & User Detection
// =====================

// =====================
// String Utilities
// =====================

// =====================
// Money Formatting
// =====================

function l_formatMoney(cents, format = '') {
	let value = ''
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	const formatString = format || window.LTATheme.money.format || '${{amount}}'

	if (typeof cents == 'string') {
		cents = cents.replace('.', '')
	}

	function defaultOption(opt, def) {
		return typeof opt == 'undefined' ? def : opt
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2)
		thousands = defaultOption(thousands, ',')
		decimal = defaultOption(decimal, '.')

		if (isNaN(number) || number == null) {
			return 0
		}

		number = (number / 100.0).toFixed(precision)

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? decimal + parts[1] : ''

		return dollars + cents
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2)
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0, ' ', '.')
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', '.')
			break
	}

	return formatString.replace(placeholderRegex, value)
}

// =====================
// Visitor/Session Utilities
// =====================

/***********************************
 * [FUNCTION]: OPEN KLAVIYO FORMS
 ************************************/

/************************************************************************************

* [ADD TO CART MODULE]

*************************************************************************************/

class LTACartServices {
	constructor(cartDrawer = null) {
		this.cartDrawer = cartDrawer
	}

	getBaseConfig() {
		return {
			method: 'POST',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
			},
		}
	}

	createConfigFromForm(formEl) {
		const config = this.getBaseConfig()
		const formData = new FormData(formEl)

		config.body = formData

		return config
	}

	createConfigFromItems(items = []) {
		const config = this.getBaseConfig()
		const formData = new FormData()

		items.forEach((item, index) => {
			const prefix = `items[${index}]`

			formData.append(`${prefix}[id]`, item.id)
			formData.append(`${prefix}[quantity]`, item.quantity)
			if (item.selling_plan) {
				formData.append(`${prefix}[selling_plan]`, item.selling_plan)
			}

			// Add all other properties from the item object except id, quantity, and selling_plan
			Object.entries(item).forEach(([key, value]) => {
				if (['id', 'quantity', 'selling_plan'].includes(key)) return
				// If the value is an object, serialize it as JSON
				if (typeof value === 'object' && value !== null) {
					formData.append(`${prefix}[${key}]`, JSON.stringify(value))
				} else if (value !== undefined) {
					formData.append(`${prefix}[${key}]`, value)
				}
			})
		})

		config.body = formData
		return config
	}

	async addToCart(config, id = 'default') {
		// Note: Don't use finally / catch here

		return fetch(`${window.LTATheme.routes.cart_add_url}.js`, config)
			.then((res) => res.json())
			.then((data) => {
				if (data?.status) {
					document.dispatchEvent(new CustomEvent('l:cart:error', { detail: { id, description: data.description } }))

					return data
				}

				document.dispatchEvent(new CustomEvent('l:product:added', { bubbles: true, detail: { id, response: data } }))

				return data
			})
	}

	async changeCartLineItem(formData) {
		return fetch(`${window.LTATheme.routes.cart_change_url}.js`, { ...l_fetchConfig(), body: JSON.stringify(formData) })
			.then((res) => res.json())
			.then((data) => {
				return data
			})
	}
}

const ltaCartService = new LTACartServices()

/************************************************************************************

* [GENERAL COMPONENTS]

*************************************************************************************/

/*****************************************
 * [COMPONENT]: COLLAPSIBLE TAB
 ******************************************/

class LTACollapsibleTab extends HTMLElement {
	constructor() {
		super()

		// Store the event handler as a property
		this._onTriggerClick = (e) => this.toggle(e)
	}

	connectedCallback() {
		// Elements
		this.triggerEl = this.querySelector('[data-trigger]')
		this.contentEl = this.querySelector('[data-content]')

		// Data
		this.expandedClass = 'is-expanded'
		this.collapsedClass = 'is-collapsed'
		this.collapsedHeight = '0px'
		this.oneAtATime = true
		this.isScrollIntoView = this.dataset.scrollIntoView === 'true'

		this.transitionendEvent = this.transitionendEventName()

		// Setup default behavior / data
		this.dataset.oneOpen === 'false' && (this.oneAtATime = false)

		if (this.getAttribute('open') === 'true') {
			this.selected = true
			this.contentEl.removeAttribute('hidden')
			this.contentEl.classList.remove('l-hidden')
			this.classList.add(this.expandedClass)
			this.setExpandedAria(false)
		} else {
			this.contentEl.style.height = this.collapsedHeight
			this.classList.add(this.collapsedClass)
			this.setCollapsedAria(null, false)
		}

		// Add event listener using stored reference
		this.triggerEl.addEventListener('click', this._onTriggerClick)
	}

	toggle(e) {
		e.preventDefault()

		this.selected ? this.close() : this.open()

		/* Close another tab and open only the current tab. */
		if (this.selected && this.oneAtATime) {
			const tabsContainer = this.closest('[data-collapsible-wrapper]')
			const collapsibleTabs = tabsContainer?.querySelectorAll('l-collapsible-tab')

			collapsibleTabs?.length &&
				collapsibleTabs.forEach((tab) => {
					tab !== this && tab.selected && tabsContainer !== tab && tab.close()
				})
		}
	}

	open() {
		this.selected = true
		this.expand()

		this.setExpandedAria()
	}

	close() {
		this.selected = false
		this.collapse()

		this.setCollapsedAria()
	}

	expand() {
		const onTransitionEnd = ((event) => {
			if (event.target === this.contentEl) {
				this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)

				this.isOpen &&
					requestAnimationFrame(() => {
						this.contentEl.style.transition = '0'
						this.contentEl.style.height = 'auto'

						requestAnimationFrame(() => {
							this.contentEl.style.height = null
							this.contentEl.style.transition = null
						})
					})
			}
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = true

		this.contentEl.removeAttribute('hidden')
		this.contentEl.classList.remove('l-hidden')

		this.classList.add(this.expandedClass)
		this.classList.remove(this.collapsedClass)

		this.contentEl.style.height = this.contentEl.scrollHeight + 'px'
	}

	collapse() {
		const onTransitionEnd = ((event) => {
			if (event.target === this.contentEl) {
				this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)

				if (!this.isOpen) {
					this.classList.add(this.collapsedClass)
				}

				this.contentEl.setAttribute('hidden', 'hidden')
				this.contentEl.classList.add('l-hidden')
			}
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = false
		this.classList.remove(this.expandedClass)

		requestAnimationFrame(() => {
			this.contentEl.style.transition = '0'
			this.contentEl.style.height = this.contentEl.scrollHeight + 'px'

			requestAnimationFrame(() => {
				this.contentEl.style.transition = null
				this.contentEl.style.height = this.collapsedHeight
			})
		})

		if (this.isScrollIntoView) {
			l_debounce(() => {
				this.scrollIntoView({ behavior: 'smooth', block: 'center' })
			}, 400)()
		}
	}

	destroy() {
		// Remove event listener using the same stored reference
		this.triggerEl && this.triggerEl.removeEventListener('click', this._onTriggerClick)
		this.contentEl && this.contentEl.removeAttribute('aria-hidden')
		this.contentEl && (this.contentEl.style.height = 'auto')

		this.classList.remove(this.expandedClass, this.collapsedClass)
		this.removeAttribute('open')
	}

	transitionendEventName() {
		let eventName,
			testElement = document.createElement('div'),
			eventNames = {
				transition: 'transitionend',
				OTransition: 'otransitionend',
				MozTransition: 'transitionend',
				WebkitTransition: 'webkitTransitionEnd',
			}

		for (eventName in eventNames) {
			if (eventNames.hasOwnProperty(eventName) && testElement.style[eventName] !== false) {
				return eventNames[eventName]
			}
		}
	}

	setExpandedAria(autoFocus = true) {
		this.setAttribute('open', true)

		this.triggerEl.setAttribute('aria-expanded', 'true')
		this.contentEl.removeAttribute('aria-hidden')
		this.contentEl.removeAttribute('tabindex')

		if (autoFocus) {
			l_enableFocusableElements(this.contentEl)
			l_trapFocus(this)
		}
	}

	setCollapsedAria(elementToFocus = this.triggerEl, enableTrapFocus = true) {
		this.removeAttribute('open')

		this.triggerEl.setAttribute('aria-expanded', 'false')
		this.contentEl.setAttribute('aria-hidden', 'true')
		this.contentEl.setAttribute('tabindex', '-1')

		l_disableFocusableElements(this.contentEl)
		enableTrapFocus && l_removeTrapFocus(elementToFocus)
	}
}

customElements.define('l-collapsible-tab', LTACollapsibleTab)

/*****************************************
 * [COMPONENT]: SWIPER CAROUSEL
 ******************************************/

class LTASwiperCarousel extends HTMLElement {
	constructor() {
		super()
		this._onResize = this._onResize.bind(this)
		this._swiperInitialized = false
	}

	connectedCallback() {
		if (window?.Swiper) {
			this.setupCarousel()
			return
		}

		document.addEventListener('l:vendor:loaded', () => {
			this.setupCarousel()
		})
	}

	disconnectedCallback() {
		window.removeEventListener('resize', this._onResize)
	}

	setupCarousel() {
		const configNode = this.querySelector('[data-carousel-config]')
		if (!configNode) return

		this.carouselConfig = JSON.parse(configNode.textContent)
		if (!this.carouselConfig) return

		this.swiperSlideEls = this.querySelectorAll('.swiper-slide')

		this.classList.remove('is-placeholder')
		this.swiperSlideEls.forEach((swiperSlide) => swiperSlide.classList.remove('l-hidden'))

		this.swiperCarousel = new window.Swiper(this, this.carouselConfig)
		this._swiperInitialized = true

		// Design mode scroll
		if (window.Shopify?.designMode) {
			this.designModeScroll()
		}

		// Set up navigation top position
		const hasNavigationTarget = this.carouselConfig?.navigation && this.carouselConfig.navigation.navigationHeightTarget
		if (hasNavigationTarget) {
			this.setupNavigation()
			window.addEventListener('resize', this._onResize)
		}

		// Dispatch event
		if (this.dataset.dispatchEvent === 'true') {
			this.dispatchEvent(
				new CustomEvent('l:swiper:carousel:loaded', {
					bubbles: true,
					detail: {
						id: this.id || this.dataset.id || 'default',
					},
				})
			)
		}
	}

	_onResize() {
		// Re-setup navigation when window resizes
		if (this._swiperInitialized && this.carouselConfig?.navigation?.navigationHeightTarget) {
			this.setupNavigation()
		}
	}

	setupNavigation() {
		const navigation = this.carouselConfig?.navigation
		if (!navigation || !navigation.navigationHeightTarget) return

		const targetEl = this.querySelector(navigation.navigationHeightTarget)
		if (!targetEl) return

		const navTop = `${targetEl.offsetHeight / 2}px`

		const nextNavEls = document.querySelectorAll(navigation.nextEl)
		const prevNavEls = document.querySelectorAll(navigation.prevEl)

		nextNavEls.forEach((el) => el.style.setProperty('--l-swiper-top', navTop))
		prevNavEls.forEach((el) => el.style.setProperty('--l-swiper-top', navTop))
	}

	designModeScroll() {
		document.addEventListener('shopify:block:select', (event) => {
			const targetEl = event.target

			this.swiperSlideEls.forEach((swiperSlide, index0) => {
				if (targetEl === swiperSlide) this.slideTo(index0)
			})
		})
	}

	slideTo(index = 0) {
		if (this.swiperCarousel && typeof this.swiperCarousel.slideTo === 'function') {
			this.swiperCarousel.slideTo(index)
		}
	}
}

customElements.define('l-swiper-carousel', LTASwiperCarousel)

/*****************************************
 * [COMPONENT]: MEDIA VIDEO
 ******************************************/

class LTAMediaVideo extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		// Elements
		this.videoContainerEl = this.querySelector('[data-video-container]') || this

		// Click
		this.addEventListener('click', (event) => {
			const hasLoaded = this.classList.contains('is-loaded')
			const isPlaying = this.classList.contains('is-playing')

			hasLoaded ? (isPlaying ? this.pauseVideo() : this.playVideo()) : this.initPlayer(event)
		})
	}

	initPlayer(event) {
		event.preventDefault()

		const templateEl = this.querySelector('template')

		if (!templateEl) return

		this.pauseOtherVideos()

		// Add template content to the element
		const templateContentEl = templateEl.content.cloneNode(true)

		this.videoContainerEl.appendChild(templateContentEl)
		this.classList.add('is-loaded', 'is-playing')
	}

	playVideo() {
		this.pauseOtherVideos()
		l_playMedia(this)

		this.classList.add('is-playing')
		this.classList.remove('is-paused')
	}

	pauseVideo() {
		l_pauseAllMedia(this)

		this.classList.remove('is-playing')
		this.classList.add('is-paused')
	}

	pauseOtherVideos() {
		l_pauseAllMedia(this.parentElement)

		this.parentElement.querySelectorAll('l-media-video').forEach((videoEl) => {
			const isLoaded = videoEl.classList.contains('is-loaded')

			if (isLoaded) {
				videoEl.classList.remove('is-playing')
				videoEl.classList.add('is-paused')
			}
		})
	}
}

customElements.define('l-media-video', LTAMediaVideo)

/*****************************************
 * [COMPONENT]:-DRAWER
 *****************************************/

class LTADrawer extends HTMLElement {
	constructor() {
		super()

		// Bind event handlers once to avoid event listener leaks
		this.boundDrawerCloseOutsideOnClick = this.drawer_closeOutsideOnClick.bind(this)
		this.boundDrawerCloseOutsideOnEscape = this.drawer_closeOutsideOnEscape.bind(this)
	}

	connectedCallback() {
		this.setupDrawer()
	}

	setupDrawer() {
		// Show in body
		const showInBody = this.dataset.showInBody === 'true'

		// Insert to body if needed
		if (showInBody) {
			const mainContentEl = document.getElementById('main-content')
			const isInContainer = mainContentEl.contains(this)

			if (isInContainer) {
				document.body.appendChild(this)
				return
			}
		}

		// Insert template content
		const templateEl = this.querySelector('template')
		if (templateEl) {
			const templateContentEl = templateEl.content.cloneNode(true)
			this.appendChild(templateContentEl)
		}

		this.drawer_init()
	}

	drawer_init() {
		// Elements
		this.triggerEls = document.querySelectorAll(this.dataset.triggerSelector)
		this.closeBtnEls = this.querySelectorAll('[data-close]')
		this.drawerInnerEl = this.querySelector('[data-drawer-inner]')
		this.triggerEl = null

		if (this.dataset.closeSelector) {
			const externalCloseBtnEls = document.querySelectorAll(this.dataset.closeSelector)
			this.closeBtnEls = Array.from(this.closeBtnEls).concat(Array.from(externalCloseBtnEls))
		}

		// Data
		this.onlyOneDrawerOpen = this.dataset.onlyOneDrawerOpen === 'true'
		this.drawerName = this.dataset.drawerName || 'drawer'

		// Setup events

		// Close this drawer if another drawer is open
		if (this.onlyOneDrawerOpen) {
			document.addEventListener('l:drawer:open', (event) => {
				if (event.detail.drawerName !== this.drawerName) {
					this.drawer_close()
				}
			})
		}

		// Open event
		this.triggerEls.forEach((triggerEl) => {
			triggerEl.addEventListener('click', (event) => {
				event.preventDefault()

				this.drawer_open(triggerEl)
			})
		})

		// Close event
		this.closeBtnEls.forEach((closeBtnEl) => {
			closeBtnEl.addEventListener('click', () => {
				this.drawer_close()
			})
		})
	}

	drawer_open(triggerEl) {
		l_setupVariablesBeforeOpenModal()
		l_lockBodyScroll(this.drawerName)

		// Open drawer
		this.classList.add('is-expanding')
		this.classList.remove('l-hidden')

		requestAnimationFrame(() => {
			this.classList.add('is-active')
		})

		// Setup focus trap on main content
		if (triggerEl) {
			this.triggerEl = triggerEl
			l_trapFocus(this.drawerInnerEl, this.defaultElementToFocus)
		}

		// Set up accessibility
		this.setAttribute('aria-expanded', 'true')
		this.removeAttribute('tabindex')

		// Set global events using bound handlers
		window.addEventListener('click', this.boundDrawerCloseOutsideOnClick)
		window.addEventListener('keyup', this.boundDrawerCloseOutsideOnEscape)

		// Dispatch event to notify that the drawer is open
		document.dispatchEvent(
			new CustomEvent('l:drawer:open', {
				detail: { drawerName: this.drawerName },
			})
		)
	}

	drawer_close() {
		l_unLockBodyScroll(this.drawerName)

		// Close drawer
		this.classList.remove('is-active')

		window.l_debounce(() => {
			this.classList.remove('is-expanding')
			this.classList.add('l-hidden')
		}, 400)()

		// Remove focus trap
		if (this.triggerEl) {
			l_removeTrapFocus(this.triggerEl)
			this.triggerEl = null
		}

		// Remove accessibility
		this.setAttribute('aria-expanded', 'false')
		this.setAttribute('tabindex', '-1')

		// Remove global events using the same bound handlers
		window.removeEventListener('click', this.boundDrawerCloseOutsideOnClick)
		window.removeEventListener('keyup', this.boundDrawerCloseOutsideOnEscape)
	}

	drawer_closeOutsideOnClick(event) {
		if (!this.classList.contains('is-active')) return

		const target = event.target
		const triggerSelector = this.dataset.drawerTriggerSelector || 'l-drawer-trigger'
		const isDrawerTrigger = event.target.closest(triggerSelector) || event.target.tagName == triggerSelector

		const isOutsideClick =
			!this.drawerInnerEl.contains(target) &&
			!Array.from(this.triggerEls).some((el) => el.contains(target)) &&
			!isDrawerTrigger

		if (isOutsideClick) this.drawer_close()
	}

	drawer_closeOutsideOnEscape(event) {
		if (event.code.toUpperCase() === 'ESCAPE') {
			this.drawer_close()
		}
	}
}

customElements.define('l-drawer', LTADrawer)

/*****************************************
 * [COMPONENT]: DRAWER TRIGGER
 ******************************************/

class LTADrawerTrigger extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		// Elements
		this.drawerEl = document.querySelector(this.dataset.selector)

		// Events
		if (this.drawerEl) {
			this.addEventListener('click', () => {
				this.drawerEl?.drawer_open?.(this)
			})
		}
	}
}

customElements.define('l-drawer-trigger', LTADrawerTrigger)

/*****************************************
 * [COMPONENT]: QUANTITY INPUT
 ******************************************/

if (!customElements.get('l-qty-input')) {
	class LTAQtyInput extends HTMLElement {
		constructor() {
			super()

			this.onButtonClick = this.onButtonClick.bind(this)
			this.onInputChange = this.onInputChange.bind(this)
			this.onInputBeforeChange = this.onInputBeforeChange.bind(this)
		}

		connectedCallback() {
			this.input = this.querySelector('input')
			this.buttonMinus = this.querySelector("button[name='minus']")
			this.buttonPlus = this.querySelector("button[name='plus']")

			if (!this.input) return

			this.changeEvent = new Event('change', { bubbles: true })

			this.validateQtyRules()
			this.setupEventListeners()
		}

		setupEventListeners() {
			this.input.addEventListener('input', this.onInputBeforeChange)
			this.input.addEventListener('change', this.onInputChange)
			this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick))
		}

		onInputBeforeChange() {
			const value = parseInt(this.input.value)

			if (isNaN(value)) return

			const min = parseInt(this.input.min)
			const max = parseInt(this.input.max)
			let newValue = value

			if (!isNaN(min) && value < min) {
				newValue = min
			}

			if (!isNaN(max) && value > max) {
				newValue = max
			}

			if (newValue !== value) {
				this.input.value = newValue
			}
		}

		onInputChange() {
			this.validateQtyRules()
		}

		onButtonClick(event) {
			event.preventDefault()

			const previousValue = this.input.value
			const buttonName = event.target.name

			if (buttonName === 'plus') {
				this.incrementQuantity()
			} else if (buttonName === 'minus') {
				this.decrementQuantity()
			}

			if (previousValue !== this.input.value) {
				this.input.dispatchEvent(this.changeEvent)
				this.onQuantityChanged(previousValue, parseInt(this.input.value))
			}
		}

		onQuantityChanged(oldValue, newValue) {
			// Override in child classes if needed
		}

		incrementQuantity() {
			const min = parseInt(this.input.dataset.min)
			const step = parseInt(this.input.step)
			const value = parseInt(this.input.value)

			if (min > step && value === 0) {
				this.input.value = min
			} else {
				this.input.stepUp()
			}
		}

		decrementQuantity() {
			this.input.stepDown()

			const min = this.input.dataset.min
			if (min && min === this.input.value) {
				this.input.value = parseInt(this.input.min)
			}
		}

		validateQtyRules() {
			const value = parseInt(this.input.value)

			if (this.input.min && this.buttonMinus) {
				this.buttonMinus.toggleAttribute('disabled', value <= parseInt(this.input.min))
			}

			if (this.input.max && this.buttonPlus) {
				this.buttonPlus.toggleAttribute('disabled', value >= parseInt(this.input.max))
			}
		}

		disconnectedCallback() {
			if (this.input) {
				this.input.removeEventListener('input', this.onInputBeforeChange)
				this.input.removeEventListener('change', this.onInputChange)
			}

			this.querySelectorAll('button').forEach((button) => button.removeEventListener('click', this.onButtonClick))
		}
	}

	customElements.define('l-qty-input', LTAQtyInput)
}

/**********************************
 * HANDLE UPDATE CART COUNT
 **********************************/

function l_updateCartCount(itemCount) {
	const cartCountEls = document.querySelectorAll('[data-js-cart-count]')
	cartCountEls.forEach((cartCountEl) => {
		cartCountEl.innerHTML = itemCount
	})
}

async function l_fetchAndUpdateCartCount() {
	try {
		const res = await fetch(`${window.LTATheme.routes.cart_url}.js`)
		const cartData = await res.json()

		console.log(cartData)

		l_updateCartCount(cartData.item_count)
	} catch (error) {
		console.error('Error fetching cart count:', error)
	}
}

document.addEventListener('l:product:added', l_fetchAndUpdateCartCount)
document.addEventListener('l:cart:error', l_fetchAndUpdateCartCount)

